import { baseApi } from '@/services/index';

const resource = process.env.VUE_APP_RESOURCE_SIREJECUTAREPORTES;

export default {
  post(payload) {
    return baseApi.post(resource, payload);
  },
};
